import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Eye } from 'lucide-react';
import { useOrganizador } from '../../contexts/OrganizadorContext';
import leiloesService from '../../services/leiloesService';

const CatalogoPisteiroList = () => {
  const navigate = useNavigate();
  const { organizadorAtivo } = useOrganizador();
  const [leiloes, setLeiloes] = useState([]);
  const [selectedLeilao, setSelectedLeilao] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (organizadorAtivo?.id) {
      carregarLeiloes();
    }
  }, [organizadorAtivo]);

  useEffect(() => {
    if (selectedLeilao) {
      navigate(`/catalogos/pisteiro/${selectedLeilao}`);
    }
  }, [selectedLeilao, navigate]);

  const carregarLeiloes = async () => {
    try {
      setLoading(true);
      const data = await leiloesService.getByOrganizador(organizadorAtivo.id);
      setLeiloes(data || []);
      if (data && data.length > 0) {
        const ativo = data.find(l => l.status === 'on') || data[0];
        setSelectedLeilao(ativo.id.toString());
      }
    } catch (error) {
      console.error('Erro ao carregar leilões:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleVerCatalogo = () => {
    if (selectedLeilao) {
      navigate(`/catalogos/pisteiro/${selectedLeilao}`);
    }
  };

  if (loading) {
    return (
      <div className="h-64 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-4 sm:space-y-6">
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl px-4 sm:px-6 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4">
            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-3xl font-bold text-white">Catálogos Pisteiro</h1>
              <p className="text-purple-100 mt-1 text-sm sm:text-base">
                Selecione um leilão para visualizar e imprimir o catálogo pisteiro
              </p>
            </div>
            <button
              onClick={handleVerCatalogo}
              disabled={!selectedLeilao}
              className="w-full sm:w-auto bg-white hover:bg-gray-100 text-purple-600 px-4 sm:px-6 py-3 rounded-xl flex items-center justify-center gap-2 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 font-medium text-sm sm:text-base"
            >
              <Eye size={18} />
              Ver Catálogo
            </button>
          </div>
        </div>

        {/* Seletor de Leilão */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-3 sm:p-6">
          <div className="grid grid-cols-1 gap-3 sm:gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Leilão</label>
              <select
                value={selectedLeilao}
                onChange={(e) => setSelectedLeilao(e.target.value)}
                className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm sm:text-base"
              >
                <option value="">Selecione um leilão...</option>
                {leiloes.map(leilao => (
                  <option key={leilao.id} value={leilao.id}>
                    {leilao.nome} - {new Date(leilao.data_leilao).toLocaleDateString('pt-BR')}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Conteúdo */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100">
          {selectedLeilao ? (
            <div className="text-center py-16">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FileText size={32} className="text-purple-600" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Catálogo Pisteiro Pronto</h3>
              <p className="text-gray-500 mb-6 max-w-md mx-auto">
                Clique no botão "Ver Catálogo" para visualizar e imprimir o catálogo pisteiro do leilão selecionado
              </p>
              <button
                onClick={handleVerCatalogo}
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-xl transition-all shadow-lg hover:shadow-xl font-medium flex items-center gap-2 mx-auto"
              >
                <Eye size={20} />
                Ver Catálogo
              </button>
            </div>
          ) : (
            <div className="text-center py-16">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FileText size={32} className="text-gray-400" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Selecione um leilão</h3>
              <p className="text-gray-500 max-w-md mx-auto">
                Escolha um leilão para visualizar e imprimir o catálogo pisteiro
              </p>
            </div>
          )}
        </div>
    </div>
  );
};

export default CatalogoPisteiroList;